<template>
  <div
    class="content category-course-list"
    :class="{
      'electron-course-list': isElectron,
      'h5-category-course-list': isH5,
    }"
  >
    <!-- 空状态 -->
    <el-empty
      v-if="!courseList.length"
      description="暂无内容"
      :image="require('@/assets/img/live-list/empty.png')"
    ></el-empty>
    <div v-else class="course-list">
      <!-- :groupInfo="item.group_buy_info || {}" -->
      <CourseCard
        v-for="item in courseList"
        :key="item.id"
        :courseInfo="item"
      />
    </div>
  </div>
</template>

<script>
import { isH5 } from "@saas/components";
import CourseCard from "./components/CourseCard";
import { getCourseList } from "@saas/server-api/src/course";
import { getCourseState } from "@saas/server-api/src/course";
export default {
  props: {
    categoryId: {
      type: Number,
      default: 0,
    },
  },
  data: function () {
    return {
      isH5: isH5(),
      page_size: 12,
      page_no: 1,
      courseList: [],
      loading: false,
      noMore: false,
      isElectron: window.isElectron,
    };
  },
  mounted() {
    //监听页面滚动
    this.$nextTick(() => {
      setTimeout(() => {
        if (window.isElectron) {
          let elMain = document.getElementById("electron-main");
          if (!elMain) return;
          elMain.addEventListener("scroll", this.scrollElectronFn, true);
        }
      }, 1000);
    });
    if (!window.isElectron) {
      window.addEventListener("scroll", this.scrollFn, true);
    }
  },
  beforeDestroy() {
    //销毁滚动事件
    if (window.isElectron) {
      let elMain = document.getElementById("electron-main");
      if (!elMain) return;
      elMain.removeEventListener("scroll", this.scrollElectronFn, true);
    } else {
      window.removeEventListener("scroll", this.scrollFn, true);
    }
  },
  methods: {
    scrollElectronFn(event) {
      if (this.loading) return false;
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 触底-加载下一页
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        if (!this.noMore) {
          this.page_no++;
          this.apiGetCourseList();
        }
      }
    },
    scrollFn() {
      if (this.loading) return false;
      //获取网页的总高度
      var htmlHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;
      //clientHeight是网页在浏览器中的可视高度
      var clientHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      //scrollTop是浏览器滚动条的top位置
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      //判断到底部了
      if (scrollTop + clientHeight > htmlHeight - 100) {
        if (!this.noMore) {
          this.page_no++;
          this.apiGetCourseList();
        }
      }
    },
    apiGetCourseList(categoryId) {
      this.loading = true;
      let params = {
        category_id: this.categoryId,
        page_size: this.page_size,
        page_no: this.page_no,
      };
      getCourseList(params)
        .then((res) => {
          const { code, data = {}, message } = res;
          if (code === 1) {
            this.handleCourseStatus(data?.list);
            // 处理课程状态标签
            if (params.page_no === 1) {
              this.courseList = data?.list || [];
            } else {
              this.courseList = this.courseList.concat(data?.list || []);
            }
            if (this.courseList.length === res.data.total) {
              this.noMore = true;
            } else {
              this.noMore = false;
            }
          } else {
            this.$message.error(message);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleCourseStatus(list = []) {
      let ids = list.map((item) => item.id);
      if (ids?.length) {
        getCourseState({
          course_id: ids.join(","),
        }).then((res) => {
          if (res.code === 1 && res.data?.length) {
            let haveStatusIds = res.data.map((item) => item.course_id);
            list.forEach((course) => {
              if (haveStatusIds.includes(course.id)) {
                let { trial_state, live_state } = res.data.find(
                  (item) => item.course_id === course.id
                );
                this.$set(course, "trial_state", trial_state);
                this.$set(course, "live_state", live_state);
              }
            });
          }
        });
      }
    },
  },
  watch: {
    categoryId: {
      handler: function (newVal) {
        if (newVal) {
          // 初始化
          this.courseList = [];
          this.page_no = 1;
          this.apiGetCourseList(newVal);
        }
      },
      immediate: true, // 设置为true，以便在初次渲染时执行handler
    },
  },
  components: {
    CourseCard,
  },
};
</script>

<style lang="scss" scoped>
.category-course-list {
  padding-top: 20px;
  background: #fff;
  .course-list {
    display: flex;
    flex-wrap: wrap;
  }
}
::v-deep.category-course-list .el-empty {
  height: 500px;
}

// 客户端
.electron-course-list {
  width: 980px;
  background: transparent;
}

// h5
.h5-category-course-list.category-course-list {
  background: #f5f5f6;
  padding: 0.3rem;
  width: 100%;
}
</style>
